// Reducer
import { reducer as startupReducer } from './reducers/startupReducer'

const rootReducer = {
  startup: startupReducer
}

export default rootReducer
